import { TrailSearchResult } from '@alltrails/search/types/algoliaResultTypes';

const convertResults = (initialResults?: TrailSearchResult[]) => {
  let convertedResults: any[] = [];
  if (!initialResults) {
    return convertedResults;
  } else {
    const filteredResults = initialResults.filter(result => result._geoloc !== undefined);
    filteredResults?.forEach?.(result => {
      if (result._geoloc) {
        const convertedResult = {
          ...result,
          _geoloc: result._geoloc,
          _cluster_geoloc: result?._cluster_geoloc,
          ID: String(result.ID) || String(result.id),
          type: result.type
        };

        if (convertedResult) {
          convertedResults.push(convertedResult);
        }
      }
    });
  }

  return convertedResults;
};

export default convertResults;
